export const connectWebSocket = (userId: string) => ({
  type: 'WEBSOCKET_CONNECT',
  payload: { userId },
});

export const disconnectWebSocket = () => ({
  type: 'WEBSOCKET_DISCONNECT',
});
